import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTransferOwnershipLists(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('customer/transfer-ownership/list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
